var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-form-base',{attrs:{"model":_vm.question,"schema":_vm.schema},on:{"click":_vm.onInput,"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }